import { apiClient } from '../client';
import { PaginatedResponse } from './role.repository';

export interface ClientCompetitor {
    id: number;
    tenant_id: number;
    sku_id: number;
    brand_en_name: string;
    brand_ar_name: string;
    sku_en_name: string;
    sku_ar_name: string;
    created_at: string;
    updated_at: string;
    our_sku_en_name?: string;
    our_sku_code?: string;
}

export interface ClientCompetitorPayload {
    sku_id: number;
    brand_en_name: string;
    brand_ar_name?: string;
    sku_en_name: string;
    sku_ar_name?: string;
}

export interface BulkCompetitorPayload {
    sku_id: number;
    competitors: Omit<ClientCompetitorPayload, 'sku_id'>[];
}

class ClientCompetitorRepository {
    async getAll(
        page = 1,
        limit = 10,
        filters?: { search?: string; sku_id?: number },
    ): Promise<PaginatedResponse<ClientCompetitor>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        });
        if (filters?.search) params.append('search', filters.search);
        if (filters?.sku_id) params.append('sku_id', filters.sku_id.toString());

        return apiClient.get<PaginatedResponse<ClientCompetitor>>(`/client-competitors?${params}`);
    }

    async create(data: ClientCompetitorPayload): Promise<ClientCompetitor> {
        return apiClient.post<ClientCompetitor>('/client-competitors', data);
    }

    async bulkCreate(data: BulkCompetitorPayload): Promise<{ message: string; created: number }> {
        return apiClient.post<{ message: string; created: number }>('/client-competitors/bulk', data);
    }

    async update(id: number, data: ClientCompetitorPayload): Promise<ClientCompetitor> {
        return apiClient.put<ClientCompetitor>(`/client-competitors/${id}`, data);
    }

    async remove(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/client-competitors/${id}`);
    }
}

export const clientCompetitorRepository = new ClientCompetitorRepository();
